import { styled } from "@mui/material"

export const FormHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  position: "relative"
})